export { default } from 'cccisd-game-nottetris';
